import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: true,
  env: 'production',
  auth: {
    host: 'https://auth.cloudclass.com.br',
    prefix: '/api/v1/auth',
  },
  api: {
    host: 'https://api.cloudclass.com.br',
    prefix: '/api/v1',
  },
  socket: {
    url: 'https://api.cloudclass.com.br',
  },
  social: {
    googleClientId: '347752138759-f3cd9ivuuhdua0a9ql6olvc8a3mbs7ll.apps.googleusercontent.com',
    facebookAppId: '27540909878941769',
  },
};
